import { GraphQLClient } from 'graphql-request'

const domain = process.env.GATSBY_SHOPIFY_STOREFRONT_DOMAIN || 'not-pot.myshopify.com'
const apiVersion = process.env.GATSBY_SHOPIFY_API_VERSION || '2024-01'
const token = process.env.GATSBY_SHOPIFY_STOREFRONT_TOKEN || process.env.GATSBY_SHOPIFY_SECRET || ''

if (!token && typeof window !== 'undefined') {
  console.error('Warning: GATSBY_SHOPIFY_STOREFRONT_TOKEN is not set. Shopify client may not work correctly.')
}

export const shopify = new GraphQLClient(
  `https://${domain}/api/${apiVersion}/graphql.json`,
  {
    headers: {
      'X-Shopify-Storefront-Access-Token': token,
    },
  }
)